import { render, staticRenderFns } from "./EoyFactsArea.vue?vue&type=template&id=6b065bbf&scoped=true&"
import script from "./EoyFactsArea.vue?vue&type=script&lang=js&"
export * from "./EoyFactsArea.vue?vue&type=script&lang=js&"
import style0 from "./EoyFactsArea.vue?vue&type=style&index=0&id=6b065bbf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b065bbf",
  null
  
)

export default component.exports